import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider as JotaiProvider } from 'jotai'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { ModalProvider } from './hooks/useModal'
import { NavigationProvider } from './hooks/useNavigation'
import { themeClass } from './theme.css.ts'
import { TelegramMiniAppProvider } from './tma.tsx'
import { createTrpcClient, trpc } from './utils/index.ts'

Sentry.init({
  dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
  sendDefaultPii: true,
  // release: import.meta.env.VITE_RELEASE_SHA,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  debug: import.meta.env.MODE === 'development',
})

const rootEl = document.getElementById('root')

if (!rootEl) {
  throw new Error('There is no root element.')
}

const queryClient = new QueryClient()
const trpcClient = createTrpcClient()

createRoot(rootEl).render(
  <Sentry.ErrorBoundary
    fallback={<p>An error has occurred. Try to reload the page.</p>}
  >
    <JotaiProvider>
      <trpc.Provider
        client={trpcClient}
        queryClient={queryClient}
      >
        <QueryClientProvider client={queryClient}>
          <TelegramMiniAppProvider>
            <NavigationProvider>
              <ModalProvider>
                <App />
              </ModalProvider>
            </NavigationProvider>
          </TelegramMiniAppProvider>
        </QueryClientProvider>
      </trpc.Provider>
    </JotaiProvider>
  </Sentry.ErrorBoundary>,
)

rootEl.classList.add(themeClass)
